import { Link } from 'react-router-dom';
import { events } from '../data/events';

function Events() {
  return (
    <div className="home-container events-page">
      {events.map((event, index) => {
        const [when, place] = event.meta.split(' · ');
        return (
          <section
            key={event.id}
            className={`home-section event-section${index % 2 === 1 ? ' event-section--alt' : ''}`}
            aria-labelledby={`event-${event.id}`}
          >
            <div className="section-inner">
              <article>
                {event.date && (
                  <p className="event-date">
                    <time dateTime={event.dateISO}>{event.date}</time>
                  </p>
                )}
                <h2 className="event-title" id={`event-${event.id}`}>
                  <Link to={`/events/${event.id}`}>{event.title}</Link>
                </h2>
                <div className={`event-layout${index % 2 === 1 ? ' event-layout--reverse' : ''}`}>
                  <div className="event-media">
                    <Link
                      to={`/events/${event.id}`}
                      className="event-media-link"
                      aria-label={event.title}
                    >
                      <img src={event.image} alt={event.alt} loading={index === 0 ? 'eager' : 'lazy'} />
                    </Link>
                  </div>
                  <div className="event-copy">
                    <p className="event-meta">
                      {when}
                      {place && (
                        <>
                          <br />
                          {place}
                        </>
                      )}
                    </p>
                    <p className="event-summary">{event.summary}</p>
                    <p className="event-register">
                      <Link to={`/events/${event.id}`}>Mehr erfahren</Link>
                    </p>
                  </div>
                </div>
              </article>
            </div>
          </section>
        );
      })}
    </div>
  );
}

export default Events;
